export default "__VITE_ASSET__BaF4jw2d__"